module.exports = __webpack_public_path__ + "img/rule6.58aaa65a.png";